/* eslint-disable import/no-anonymous-default-export */
export default (advice = [], action) => {
  switch (action.type) {
    case "GET_HEAD_OFFICE_ADVICE":
      return action.payload;
    case "CLEAR_ADVISE":
      return advice.map((data) => {
        return {
          ...data,
          history: data.history.filter((item) => item._id !== action.payload),
        };
      });

    default:
      return advice;
  }
};
